module.exports = __webpack_public_path__ + "media/src/images/progress/dentals_5-13dc9ea95d04f796ac8c5388b1bf2bf3.jpg";